import { client } from './client';

// --- Dashboard ---

export const getDashboardSummary = async () => {
    const response = await client.get('/v1/dashboard/summary');
    return response.data;
};

export const getDashboardInvoices = async (params = {}) => {
    const response = await client.get('/v1/dashboard/invoices', { params });
    return response.data;
};
